<template>
  <div>
    <h3 class="text-primary font-weight-bold mb-2">{{ nombre || 'Título del paquete' }}</h3>
    <b-row>
      <b-col md="7" class="mb-2">
        <div class="preview-image-wrapper">
          <img :src="imagenSrc" alt="Portada" class="img-fluid rounded preview-image"/>
        </div>
        <b-card v-if="descripcion" class="mt-2">
          <div class="text-justify" style="white-space: pre-line;">{{ descripcion }}</div>
        </b-card>
      </b-col>
      <b-col md="5">
        <div class="price-box mb-2">
          <div class="text-muted small">Precio</div>
          <div class="h2 text-primary mb-0">{{ precioFmt }}</div>
        </div>

        <b-card bg-variant="light" class="mb-2">
          <div v-for="cat in categoriasConItems" :key="cat" class="mb-2">
            <div class="font-weight-bold text-primary mb-1">{{ labelsCategorias[cat] }}</div>
            <ol class="mb-0 pl-3">
              <li v-for="(it, idx) in listaPorCategoria[cat]" :key="cat+'-'+idx">{{ it }}</li>
            </ol>
          </div>
        </b-card>

        <b-card v-if="beneficiosList.length" bg-variant="light" class="mb-2">
          <div class="font-weight-bold text-primary mb-1">Beneficios</div>
          <ul class="mb-0 pl-3">
            <li v-for="(b, i) in beneficiosList" :key="'b-'+i">{{ b }}</li>
          </ul>
        </b-card>

        <b-card v-if="notasPaciente" class="mb-2">
          <div class="font-weight-bold mb-1">Notas al paciente</div>
          <div class="text-justify" style="white-space: pre-line;">{{ notasPaciente }}</div>
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'

export default {
  name: 'PaqVistaPrevia',
  components: { BRow, BCol, BCard },
  props: {
    nombre: String,
    precio: [Number, String],
    imagenSrc: { type: String, default: '' },
    categorias: { type: Object, required: true },
    labelsCategorias: { type: Object, required: true },
    beneficios: { type: Object, required: true },
    notasPaciente: { type: String, default: '' },
    descripcion: { type: String, default: '' },
  },
  computed: {
    precioFmt () {
      const n = Number(this.precio)
      if (Number.isFinite(n)) return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      return '$0.00'
    },
    categoriasOrden () {
      return ['laboratorio','imagenes','procedimientos','terapias','atencion_medica']
    },
    categoriasConItems () {
      const out = []
      for (const k of this.categoriasOrden) {
        const arr = this.categorias && Array.isArray(this.categorias[k]) ? this.categorias[k] : []
        if (arr.length > 0) out.push(k)
      }
      return out
    },
    listaPorCategoria () {
      const map = {}
      for (const k of this.categoriasOrden) {
        const arr = (this.categorias[k] || [])
        // Formateo especial por categoría
        if (k === 'atencion_medica') {
          map[k] = arr.map(it => {
            // Esperado desde PaqAtencionMedica: { tipo, especialidad_text, proc_descripcion }
            const esp = it.especialidad_text || ''
            const proc = it.proc_descripcion ? ` / ${it.proc_descripcion}` : ''
            const tipo = it.tipo === 'VIRTUAL' ? ' (Virtual)' : (it.tipo === 'PRESENCIAL' ? ' (Presencial)' : '')
            const txt = `${esp}${proc}${tipo}`.trim()
            return txt || 'Item'
          })
        } else {
          map[k] = arr.map(it => it.descripcion || it.label || it.codigo || 'Item')
        }
      }
      return map
    },
    beneficiosList () {
      const b = this.beneficios || {}
      const out = []
      if (b.parkingGratis) out.push('Parking gratis')
      if (b.salaVIP) out.push('Sala VIP')
      if (b.bebidas) out.push('Bebidas')
      return out
    },
  }
}
</script>

<style scoped>
.preview-image-wrapper { background: #f8f9fa; border-radius: 8px; overflow: hidden; }
.preview-image { width: 100%; object-fit: cover; max-height: 360px; }
.price-box { padding: 8px 0; }
</style>
